// components/profile

import template from './template.jade'
import style    from './style.scss'
import Store    from 'Store'

var name = 'profile/info'
var url = '/api/KontrInfo'
const store = new Store(name)

export default {

  name: name,
  template: template({style: style}),

  data: () => ({
    name: name,
    url: url,
  }),

  ready() {
    this.$set('data', store.$get(this) )
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/profile/info/index.js
 **/